// import {
//   Button,
//   ButtonProps,
//   Calendar,
//   CalendarCell,
//   CalendarGrid,
//   CalendarGridBody,
//   CalendarGridHeader,
//   CalendarHeaderCell,
//   DateInput,
//   DatePicker,
//   DateSegment,
//   Dialog,
//   Group,
//   Heading,
//   Label,
//   Popover,
//   PopoverProps,
//   Text,
// } from "react-aria-components";
// import { useFormContext } from "react-hook-form";
// import { FaCalendar } from "react-icons/fa";

// type DatePickerProps = {
//   name: string;
//   isRequired?: boolean;
//   label?: string;
//   isDisabled?: boolean;
//   minValue?: string | any;
//   maxValue?: string | any;
//   defaultValue?: any;
//   onChange: (date: any) => void;
// };

// function MyPopover(props: PopoverProps) {
//   return (
//     <Popover
//       {...props}
//       className={({ isEntering, isExiting }) => `
//           overflow-auto rounded-lg drop-shadow-lg ring-1 ring-black/10 bg-white
//           ${
//             isEntering
//               ? "animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 ease-out duration-200"
//               : ""
//           }
//           ${
//             isExiting
//               ? "animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 ease-in duration-150"
//               : ""
//           }
//         `}
//     />
//   );
// }

// function RoundButton(props: ButtonProps) {
//   return (
//     <Button
//       {...props}
//       className="w-9 h-9 outline-none cursor-default bg-transparent text-gray-600 border-0 rounded-full flex items-center justify-center hover:bg-gray-100 pressed:bg-gray-200 focus-visible:ring ring-violet-600/70 ring-offset-2"
//     />
//   );
// }

// export default function DatePickerUi({
//   name,
//   isRequired,
//   label,
//   isDisabled,
//   minValue,
//   maxValue,
//   defaultValue,
//   onChange,
//   ...props
// }: DatePickerProps) {
//   const {
//     // setValue,
//     // clearErrors,
//     formState: { errors },
//   } = useFormContext();

//   const fieldName = name || "";
//   const errorMessage = errors[fieldName] || { message: "" };
//   const error = errorMessage.message?.toString() || "";
//   return (
//     <DatePicker
//       className={`${
//         isDisabled ? " cursor-not-allowed" : ""
//       } h-12 border bg-[#FBFBFB] border-[#F0F0F0] px-3 mb-2 mx-3 w-full`}
//       {...props}
//       minValue={minValue}
//       maxValue={maxValue}
//       isDisabled={isDisabled}
//       defaultValue={defaultValue}
//       granularity="day"
//       // onChange={(e) => {
//       //   if (e.calendar) {
//       //     clearErrors(fieldName);
//       //     setValue(fieldName, e);
//       //   }
//       // }}
//       onChange={onChange}
//       aria-labelledby="datepicker-label"
//     >
//       <Label id="datepicker-label" className="sr-only">
//         {label || "Select a date"}
//       </Label>
//       <Group className={`flex items-center gap-2 h-12 w-full`}>
//         <DateInput className={`flex flex-1  w-full`}>
//           {(segment) => (
//             <DateSegment
//               className="px-0.5text-sm tabular-nums outline-none rounded-sm focus:bg-violet-700 focus:text-white caret-transparent placeholder-shown:italic"
//               segment={segment}
//             />
//           )}
//         </DateInput>
//         <Button className={` focus: outline-none`}>
//           <FaCalendar />
//         </Button>
//       </Group>
//       <Text slot="errorMessage">{error}</Text>

//       <MyPopover>
//         <Dialog className="p-6 text-gray-600">
//           <Calendar>
//             <header className="flex items-center gap-1 pb-4 px-1 font-serif w-full">
//               <Heading className="flex-1 font-semibold text-2xl ml-2" />
//               <RoundButton slot="previous">
//                 <img src="/icons/left-arrow.svg" alt="previous" />
//               </RoundButton>
//               <RoundButton slot="next">
//                 <img src="/icons/arrow-right.svg" alt="next" />
//               </RoundButton>
//             </header>
//             <CalendarGrid className="border-spacing-1 border-separate">
//               <CalendarGridHeader>
//                 {(day) => (
//                   <CalendarHeaderCell className="text-xs text-gray-500 font-semibold">
//                     {day}
//                   </CalendarHeaderCell>
//                 )}
//               </CalendarGridHeader>
//               <CalendarGridBody>
//                 {(date) => (
//                   <CalendarCell
//                     date={date}
//                     className="w-9 h-9 outline-none cursor-default rounded-full flex items-center justify-center outside-month:text-gray-300 hover:bg-gray-100 pressed:bg-gray-200 selected:bg-violet-700 selected:text-white focus-visible:ring ring-violet-600/70 ring-offset-2"
//                   />
//                 )}
//               </CalendarGridBody>
//             </CalendarGrid>
//           </Calendar>
//         </Dialog>
//       </MyPopover>
//     </DatePicker>
//   );
// }

// import type {
//   DateRangePickerProps,
//   DateValue,
//   ValidationResult,
// } from "react-aria-components";
// import {
//   Button,
//   CalendarCell,
//   CalendarGrid,
//   CalendarGridBody,
//   CalendarGridHeader,
//   CalendarHeaderCell,
//   DateInput,
//   DateRangePicker,
//   DateSegment,
//   Dialog,
//   FieldError,
//   Group,
//   Heading,
//   Label,
//   Popover,
//   RangeCalendar,
//   Text,
// } from "react-aria-components";
// import { FaCalendar } from "react-icons/fa";

// interface MyDateRangePickerProps<T extends DateValue>
//   extends DateRangePickerProps<T> {
//   label?: string;
//   description?: string;
//   errorMessage?: string | ((validation: ValidationResult) => string);
//   defaultValue: any;
//   name: string;
// }

// function DatePickerUi<T extends DateValue>({
//   label,
//   description,
//   errorMessage,
//   defaultValue,
//   ...props
// }: MyDateRangePickerProps<T>) {
//   return (
//     <DateRangePicker {...props} className="w-full flex flex-col gap-2">
//       <Label className="block">{label}</Label>
//       {/* <Group className="w-full flex items-center gap-2 px-3 py-2 rounded-md">
//         <div className="flex items-center gap-2">
//           <div className="flex">
//             <DateInput
//               slot="end"
//               className="flex items-center gap-1 border px-2 py-1 rounded-md"
//             >
//               {(segment) => <DateSegment segment={segment} />}
//             </DateInput>
//             <Button className="p-1 text-gray-600">
//               <FaCalendar />
//             </Button>
//           </div>
//           <span aria-hidden="true">–</span>
//           <div className="flex">
//             <DateInput
//               slot="end"
//               className="flex items-center gap-1 border px-2 py-1 rounded-md"
//             >
//               {(segment) => <DateSegment segment={segment} />}
//             </DateInput>
//             <Button className="p-1 text-gray-600">
//               <FaCalendar />
//             </Button>
//           </div>
//         </div>
//       </Group> */}
//       <Group className="w-full flex items-center gap-2 px-3 py-2">
//         <div className="flex items-center w-full gap-2">
//           <div className="relative flex items-center w-full">
//             <DateInput
//               slot="start"
//               className="w-full flex items-center border px-2 py-1 rounded-md pr-8"
//             >
//               {(segment) => <DateSegment segment={segment} />}
//             </DateInput>
//             <Button className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-gray-600">
//               <FaCalendar />
//             </Button>
//           </div>

//           <span aria-hidden="true">–</span>

//           <div className="relative flex items-center w-full">
//             <DateInput
//               slot="end"
//               className="w-full flex items-center border px-2 py-1 rounded-md pr-8"
//             >
//               {(segment) => <DateSegment segment={segment} />}
//             </DateInput>
//             <Button className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-gray-600">
//               <FaCalendar />
//             </Button>
//           </div>
//         </div>
//       </Group>
//       {description && (
//         <Text slot="description" className="text-sm text-gray-500">
//           {description}
//         </Text>
//       )}
//       <FieldError className="text-red-500 text-sm">{errorMessage}</FieldError>
//       <Popover>
//         <Dialog className="shadow-lg rounded-md p-3 bg-white">
//           <RangeCalendar>
//             <header className="flex justify-between items-center px-2 py-1">
//               <Button slot="previous">◀</Button>
//               <Heading />
//               <Button slot="next">▶</Button>
//             </header>

//             <CalendarGrid className="border-spacing-1 border-separate">
//               <CalendarGridHeader>
//                 {(day) => (
//                   <CalendarHeaderCell className="text-xs text-gray-500 font-semibold">
//                     {day}
//                   </CalendarHeaderCell>
//                 )}
//               </CalendarGridHeader>
//               <CalendarGridBody>
//                 {(date) => (
//                   <CalendarCell
//                     date={date}
//                     className="w-9 h-9 outline-none cursor-default rounded-full flex items-center justify-center outside-month:text-gray-300 hover:bg-gray-100 pressed:bg-gray-200 selected:bg-violet-700 selected:text-white focus-visible:ring ring-violet-600/70 ring-offset-2"
//                   />
//                 )}
//               </CalendarGridBody>
//             </CalendarGrid>
//           </RangeCalendar>
//         </Dialog>
//       </Popover>
//     </DateRangePicker>
//   );
// }

// export default DatePickerUi;

import {
  Button,
  ButtonProps,
  CalendarCell,
  CalendarGrid,
  CalendarGridBody,
  CalendarGridHeader,
  CalendarHeaderCell,
  DateInput,
  DateRangePicker,
  DateRangePickerProps,
  DateSegment,
  DateValue,
  Dialog,
  Group,
  Heading,
  I18nProvider,
  Label,
  Popover,
  PopoverProps,
  RangeCalendar,
  ValidationResult,
} from "react-aria-components";

import { FaCaretDown, FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { today, getLocalTimeZone } from "@internationalized/date";

function RoundButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      className="w-9 h-9 outline-none cursor-default bg-transparent text-gray-600 border-0 rounded-md flex items-center justify-center hover:bg-gray-100 pressed:bg-gray-200 focus-visible:ring ring-secondary ring-offset-2"
    />
  );
}

function MyPopover(props: PopoverProps) {
  return (
    <Popover
      {...props}
      className={({ isEntering, isExiting }) => `
             overflow-auto rounded-md  border bg-white
              ${
                isEntering
                  ? "animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 ease-out duration-200"
                  : ""
              }
              ${
                isExiting
                  ? "animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 ease-in duration-150"
                  : ""
              }
            `}
    />
  );
}

interface MyDateRangePickerProps<T extends DateValue>
  extends DateRangePickerProps<T> {
  label?: string;
  description?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
  defaultValue: any;
  name: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  minValue?: string | any;
  maxValue?: string | any;
}

function DatePickerUi<T extends DateValue>({
  label,
  description,
  errorMessage,
  defaultValue,
  onChange,
  ...props
}: MyDateRangePickerProps<T>) {
  const timeZone = getLocalTimeZone();
  const maxValue = today(timeZone);
  const minValue = today(timeZone).subtract({ years: 1 });

  return (
    <div className="w-full p-5">
      <I18nProvider locale="en-IN">
        <DateRangePicker
          //   className={`${isDisabled ? " cursor-not-allowed" : ""}`}
          //   {...props}
          minValue={minValue}
          maxValue={maxValue}
          //   isDisabled={isDisabled}
          //   defaultValue={defaultValue}
          //   granularity="day"
          //   onChange={(e: any) => {
          //     if (e.calendar) {
          //       clearErrors(fieldName);
          //       setValue(fieldName, e);
          //     }
          //   }}

          onChange={onChange}
        >
          <Label className="sr-only"></Label>
          <Group className="w-full mt-1 rounded-md border-0  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-secondary  sm:text-sm sm:leading-6 flex items-center justify-between px-3">
            <DateInput slot={"start"} className="flex flex-1 py-2">
              {(segment) => (
                <DateSegment
                  className="px-0.5 tabular-nums outline-none rounded-sm focus:bg-secondary focus:text-white caret-transparent placeholder-shown:italic"
                  segment={segment}
                />
              )}
            </DateInput>
            <span aria-hidden="true">–</span>

            <DateInput slot={"end"} className="flex flex-1 py-2">
              {(segment) => (
                <DateSegment
                  className="px-0.5 tabular-nums outline-none rounded-sm focus:bg-secondary focus:text-white caret-transparent placeholder-shown:italic"
                  segment={segment}
                />
              )}
            </DateInput>
            <Button className={`focus:outline-none`}>
              <FaCaretDown className="w-5 h-5 -mt-1" />
            </Button>
          </Group>

          <MyPopover>
            <Dialog className=" p-3 ">
              <RangeCalendar>
                <header className="flex items-center justify-between  pb-4 px-1  w-full">
                  <RoundButton slot="previous">
                    <FaChevronLeft className="w-5 h-5" />
                  </RoundButton>
                  <Heading className=" font-semibold" />
                  <RoundButton slot="next">
                    <FaChevronRight className="w-5 h-5" />
                  </RoundButton>
                </header>

                <CalendarGrid>
                  <CalendarGridHeader>
                    {(day) => (
                      <CalendarHeaderCell className="text-xs text-gray-500 font-semibold">
                        {day}
                      </CalendarHeaderCell>
                    )}
                  </CalendarGridHeader>

                  <CalendarGridBody className=" w-full">
                    {(date: any) => (
                      <CalendarCell
                        date={date}
                        className={({ isSelected, isDisabled }) =>
                          `w-11 h-11 outline-none cursor-default flex items-center justify-center ${
                            isSelected ? "bg-secondary text-white" : ""
                          } ${
                            isDisabled
                              ? "text-gray-200 cursor-not-allowed"
                              : "hover:bg-[#f1eef7]"
                          } text-sm`
                        }
                      />
                    )}
                  </CalendarGridBody>
                </CalendarGrid>
              </RangeCalendar>
            </Dialog>
          </MyPopover>
        </DateRangePicker>
      </I18nProvider>
    </div>
  );
}

export default DatePickerUi;
